export const ADSS_ADVANCED_MD_CONFIG = {
  officeKey: "141444",
  appName: "VALERIEHEALTH",
  selfPayFinancialClassCode: "SP",
  defaultProfileId: "146",
  homeOnlyPhoneAsMobile: true,
  selfReferralReason: "SELF-REFERRAL",
} as const;
